import React from 'react';
import { styled } from 'linaria/lib/react';
import { theme, useBreakpoint } from '@mtsbank/ui-kit';
interface Props {
  title: string;
  onClick?: () => void;
  modal?: boolean;
  cashback?: boolean;
  height?: number;
  icon?: React.ReactElement;
  startIcon?: React.ReactElement;
}
export const ButtonDone = ({
  title,
  onClick,
  modal,
  icon,
  cashback,
  height,
  startIcon
}: Props) => {
  const {
    isMobile
  } = useBreakpoint();
  return <ButtonWrapper onClick={onClick} isMobile={isMobile} modal={modal} cashback={cashback} height={height}>
      <Text cashback={cashback}>
        {startIcon && startIcon}
        {title}
        <div>{icon && icon}</div>
      </Text>
    </ButtonWrapper>;
};
const ButtonWrapper = /*#__PURE__*/styled("button")({
  name: "ButtonWrapper",
  class: "b1yti3mx",
  vars: {
    "b1yti3mx-0": [({
      modal
    }) => modal ? '#444974' : '#262b56'],
    "b1yti3mx-1": [({
      modal
    }) => modal ? '0px 4px 0px 0px rgb(28,33,76)' : '0px 4px 0px 0px rgb(7, 10, 53)'],
    "b1yti3mx-4": [({
      cashback
    }) => cashback ? '8px 10px' : '18px 10px'],
    "b1yti3mx-5": [({
      height
    }) => height ? `${height}px` : 'auto'],
    "b1yti3mx-6": [({
      modal
    }) => modal ? '#585D88' : '#3A3F6A'],
    "b1yti3mx-7": [({
      modal
    }) => modal ? '#303560' : '#121742'],
    "b1yti3mx-8": [({
      disabled
    }) => disabled ? 'none' : 'translateY(4px)']
  }
});
const Text = /*#__PURE__*/styled("div")({
  name: "Text",
  class: "t1rrsccx",
  vars: {
    "t1rrsccx-2": [({
      cashback
    }) => cashback ? '4px 8px 0px 8px' : '0']
  }
});

require("./ButtonDone.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./ButtonDone.tsx");